import RemoteStorage from './remote'
import OpfsStorage from './opfs'
import BrowserLocalStorage from './browserLocalStorage'
import { type StorageInterface } from '@/common/storageInterface'

export async function readJSON(storage: StorageInterface, rootKey: string, path: string): Promise<any|null> {
  const t = await storage.readPath(rootKey, path)
  return t == null || t.trim().length === 0 ? null : JSON.parse(t)
}

export async function writeJSON(storage: StorageInterface, rootKey: string, path: string, data: string) {
  await storage.writePath(rootKey, path, JSON.stringify(data))
}

export async function createStorage(userName: string|null|undefined): Promise<StorageInterface> {
  if (!userName) {
    throw new Error('User name parameter required')
  }

  for (const StorageClass of [RemoteStorage, OpfsStorage, BrowserLocalStorage]) {
    const instance = new StorageClass(userName)
    if (await instance.supported()) {
      return instance
    }
  }
  return new BrowserLocalStorage(userName)
}
